/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailWithRelations } from './emailWithRelations';


/**
 * (tsType: EmailTemplateWithRelations, schemaOptions: { includeRelations: true })
 */
export interface EmailTemplateWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    name: string;
    type: EmailTemplateWithRelations.TypeEnum;
    subject: string;
    htmlTemplate: string;
    requiredVariables: Array<string>;
    isActive?: boolean;
    emails?: Array<EmailWithRelations>;
}
export namespace EmailTemplateWithRelations {
    export type TypeEnum = 'welcome' | 'email_verification' | 'password_reset' | 'notification' | 'custom' | 'requisition_notification' | 'reduction_requisition_notification' | 'reservation_confirmation' | 'vacation_request_pending' | 'vacation_request_approved_by_boss' | 'vacation_request_approved_final' | 'vacation_request_rejected' | 'assessment_invitation' | 'evaluation_results' | 'normative_version_rejected' | 'normative_version_published';
    export const TypeEnum = {
        Welcome: 'welcome' as TypeEnum,
        EmailVerification: 'email_verification' as TypeEnum,
        PasswordReset: 'password_reset' as TypeEnum,
        Notification: 'notification' as TypeEnum,
        Custom: 'custom' as TypeEnum,
        RequisitionNotification: 'requisition_notification' as TypeEnum,
        ReductionRequisitionNotification: 'reduction_requisition_notification' as TypeEnum,
        ReservationConfirmation: 'reservation_confirmation' as TypeEnum,
        VacationRequestPending: 'vacation_request_pending' as TypeEnum,
        VacationRequestApprovedByBoss: 'vacation_request_approved_by_boss' as TypeEnum,
        VacationRequestApprovedFinal: 'vacation_request_approved_final' as TypeEnum,
        VacationRequestRejected: 'vacation_request_rejected' as TypeEnum,
        AssessmentInvitation: 'assessment_invitation' as TypeEnum,
        EvaluationResults: 'evaluation_results' as TypeEnum,
        NormativeVersionRejected: 'normative_version_rejected' as TypeEnum,
        NormativeVersionPublished: 'normative_version_published' as TypeEnum
    };
}


